<template>
  <svg
      xmlns:svg="http://www.w3.org/2000/svg"
       xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0"
      :class="svgClass" aria-hidden="true"
      :style="{width:`${width}px`,height:`${height}px`}"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',

  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: 24
    },
    height: {
      type: [String, Number],
      default: 24
    }
  },

  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return `svg-icon${this.className}`
      } else {
        return 'svg-icon'
      }
    }
  }

}
</script>
<style>
.svg-icon {
  display: inline-block;
  color: inherit;
  vertical-align: middle;
}
</style>
